<template>
  <l-layout v-loading="ailoading" style="background: #fff;" :right="getDescriptionWidth">
      
  </l-layout>
  
</template>
<script>

export default {
  name:'l-ai-chat-panel',
  props:{
      value:{

      },
      mode: {
          type:String,
          default: 'text/x-csharp'
      },
      CodeDescription:{
          type: String,
          default: ''
      },
      Hints: {
          type: Array,
          default: () => []
      },
      theme:{
          type:String,
          default: 'erlang-dark'
      },
      category:{
          type:String,
          default: 'formEvent'
      },
      method:{
          type:String,
          default: 'CallFunction'
      },
      params:{
          type:String,
          default: ''
      },
      readonly: Boolean,
      disabled: Boolean,
      showTools: {
          type: Boolean,
          default: true
      }
  },
  data(){
      return {
          content: '',
          ailoading : false,
          chatVisible: false
      };
  },
  computed:{
      getDescriptionWidth(){
          if(this.readonly || this.disabled)
              return 0;
          if(!!this.CodeDescription || ['text/x-csharp','application/javascript'].indexOf(this.mode) != -1)
              return 260;
          return 0;
      },
      value2:{
          get(){
              return this.value || '';
          },
          set(val){
              this.$emit('input', val);
              this.$emit('change', val);
          }
      }
  },
  methods:{
      handleChatClear(){
          this.value2 = ''
      },
      sendChat(){
          this.ailoading = true;
          var content = this.content;
          this.content = '';
          window.$api.ai.platform.chat('', { content }).then(res=>{
                this.value2 = res.data;
              this.ailoading = false
          }).catch(()=>{
              this.ailoading = false
          });
      },
      handleSavedCode(){

      },
      handleChat(){
          this.chatVisible = !this.chatVisible
      },
      handleChatClose(){
          this.chatVisible = false
      },
      handleCopy(){
          this.value2 && this.$copyText(this.value2).then(function () {
              alert('已复制')
          })
      },
      handleChecking(){
          this.validate( res=>{
              if(res){
                  this.$message.success('检查通过')
              }
          });
      },
      validate(callback){
          this.validate2(this.category, this.method, this.params, res=>{
            callback && callback(res)
          });
      },
      validate2(category, method, params, callback){
          if(this.mode == 'text/x-csharp' && !this.$validatenull(this.value2)){
              this.httpPost({url: 'code/build', params:{}, data:
              {
                  category: category,// || 'formEvent',
                  method: method,// || 'CallFunction',
                  body: this.lr_Base64Encode(this.value2),
                  arguments: params || ''
              }, callback})
          }
          else{
              callback( {res:true})
          }
      },
      handleHint(text){
          text = text.replace(/'/g,'')
          text = text.replace(/"/g,'')
          return this.Hints.filter(t=>(t.label.indexOf(text) != -1 ||  t.prop.indexOf(text) != -1))
              .map(t=>t.component?`/*${t.label}*/"${t.prop}"`:`${t.prop}`)
      },
      async httpGet({url, params,callback}){
          const res = await this.$awaitWraper(window.$axios({
              url: `${url}`,
              method: 'get',
              params
          }))
          callback && callback(res)
      },
      async httpPost({url, params,data, callback}){
          const res = await this.$awaitWraper(window.$axios({
              url: `${url}`,
              method: 'post',
              params,
              data
          }))
          callback && callback(res)
      },
      async httpPut({url, params,data,callback}){
          const res = await this.$awaitWraper(window.$axios({
              url: `${url}`,
              method: 'put',
              params,
              data
          }))
          callback && callback(res)
      },
      async httpDelete({url, params,data,callback}){
          const res = await this.$awaitWraper(window.$axios({
              url: `${url}`,
              method: 'delete',
              params,
              data
          }))
          callback && callback(res)
      },
      //创建JavaScript脚本函数
      buildFunction(strEvent) {
          if (!this.$validatenull(strEvent)) {
              strEvent = `(function(){function fn(txChina, callback) { var $p=txChina; var $this=$p.caller; ${strEvent}} return fn})()`
              return this.$getFunction(strEvent)
          }
          else {
              return { res: false, msg: '没设置脚本函数！' }
          }
      },
      //执行JavaScript脚本函数
      processEvent(strEvent, Parameters){
          return new Promise(resolve => {
              const myEvent = this.buildFunction(strEvent)
              if (myEvent.res) {
                  const result = myEvent.fn(Parameters, result => {
                      resolve({res: true, result})
                  })
                  if (result != 'callback') {
                      resolve({res: true, result})
                  }
              }
              else {
                  resolve(myEvent)
              }
          })
      },
      getValue(data, path) {
          const paths = path.split('.')
          for (let i = 0, len = paths.length; i < len; i++) {
              data = data[paths[i]]
          }
          return data
      },
      setValue(data, path, value ) {
          const paths = path.split('.')
          if (paths.length == 2) {
              this.$set(data[paths[0]], paths[1], value)
          }
          else if (paths.length == 3 && data[paths[0]]) {
              this.$set(data[paths[0]][paths[1]], paths[2], value)
          }
          else {
              this.$set(data, path, value)
          }
      }
  }
}
</script>